import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { smoothlyMenu } from '../../../app.helpers';
declare var jQuery: any;

@Component({
  selector: 'psm-topnavbar',
  templateUrl: 'topnavbar.template.html'
})
export class TopNavbarComponent {

  constructor(private authService: AuthService, private router: Router) { }

  public toggleNavigation(): void {
    jQuery('body').toggleClass('mini-navbar');
    smoothlyMenu();
  }

  public logOut() {
    this.authService.logOut();
    this.router.navigateByUrl('/user/login');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/common/topnavbar/topnavbar.component.ts